import { useLocation } from "react-router-dom";
import Header from "./Header";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const hideHeaderRoutes = [
    "/bid-request",
    "/registration-success",
    "/bid-request-success",
  ]; // Add more if needed

  // Print views are sheets handed to a client. The nav belongs to the app, and
  // its dark buttons print as black chunks across the top of the page. The ids
  // in these routes are dynamic, so match the suffix rather than the path.
  const isPrintRoute = location.pathname.endsWith("/print");

  const hideHeader =
    hideHeaderRoutes.includes(location.pathname) || isPrintRoute;

  return (
    <>
      {!hideHeader && <Header />}
      {children}
    </>
  );
};

export default Layout;
